import axios from '../utils/axios';

export default function fetchRecruiterIncomplete(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/incomplete-recruiter', { params })
            .then(res => {
                return res.data;
            }).catch(err => {
                return err;
            })
    )
}